import { render, staticRenderFns } from "./CommitteeMemberList.vue?vue&type=template&id=67edf8a3"
import script from "./CommitteeMemberList.vue?vue&type=script&lang=js"
export * from "./CommitteeMemberList.vue?vue&type=script&lang=js"
import style0 from "./CommitteeMemberList.vue?vue&type=style&index=0&id=67edf8a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports